import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { DELIVERY_NOTE_GENERATE_LABELS } from "constants/forms";
import DeliveryNoteExportSheet from "./DeliveryNoteExportSheet";
import DeliveryNotePreviewColumn from "./DeliveryNotePreviewColumn";
import DeliveryNoteTemplatePreview from "./DeliveryNoteTemplatePreview";

const DeliveryNoteDocumentPreview = ({
  snapshot,
  resolveImage,
  note,
  isExporting,
  exportRef,
  showTitle = true,
}) => {
  if (!snapshot) {
    return (
      <DeliveryNotePreviewColumn showTitle={showTitle}>
        <div
          className="delivery-note-preview-placeholder"
          id="delivery-note-preview-placeholder"
        >
          <Typography
            className="text-3 violet"
            type="p"
            label={
              <FormattedMessage
                {...DELIVERY_NOTE_GENERATE_LABELS.emptyPreview}
              />
            }
          />
        </div>
      </DeliveryNotePreviewColumn>
    );
  }

  return (
    <>
      <DeliveryNoteTemplatePreview
        snapshot={snapshot}
        resolveImage={resolveImage}
        showTitle={showTitle}
        showPlaceholders={false}
        note={note}
      />

      {isExporting && (
        <DeliveryNoteExportSheet
          snapshot={snapshot}
          resolveImage={resolveImage}
          note={note}
          sheetRef={exportRef}
        />
      )}
    </>
  );
};

DeliveryNoteDocumentPreview.propTypes = {
  snapshot: PropTypes.object,
  resolveImage: PropTypes.func.isRequired,
  note: PropTypes.object,
  isExporting: PropTypes.bool,
  exportRef: PropTypes.object,
  showTitle: PropTypes.bool,
};

export default DeliveryNoteDocumentPreview;
